"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = _interopRequireDefault(require("./icons.js"));
var _antDesignVue = require("ant-design-vue");
// 自定义 svg 图标列表：iconsMap的key值就是图标使用时的type属性值

// 自定义 font 图标：iconfont.cn的js文件中symbol标签的id属性值就是图标使用时的type属性值

const IconFont = _antDesignVue.Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2787014_2btlymmyvs5.js' // iconfont.cn 项目在线生成的 js 地址
});
var _default = exports.default = {
  name: 'BasisIcon',
  // 基础图标组件，支持自定义svg图标、IconFont图标以及AntDesignVue的Icon图标组件
  components: {
    IconFont
  },
  props: {
    // 使用哪个属性来显示
    attr: {
      type: String,
      default: 'type',
      validator: value => {
        // type对应默认的type component使用自定义SVG图标 iconfont使用自定义iconfont图标
        return ['type', 'component', 'iconfont'].indexOf(value) !== -1;
      }
    },
    // 图标类型。遵循图标的命名规范 如果为iconfont，this.type必须以“icon-”开头
    type: {
      type: String,
      default: ''
    },
    // 取值是100或100px，可以不带单位
    size: {
      type: [Number, String],
      default: '1em'
    },
    // 有时会出现改变颜色图标颜色不会发生改变的情况，这时打开svg文件删除style标签里的每一项fill样式设置，这样就可以实现颜色自由切换了
    color: {
      type: String,
      default: 'inherit'
    },
    // margin-top
    mt: {
      type: [Number, String],
      default: 0
    },
    // margin-right
    mr: {
      type: [Number, String],
      default: 0
    },
    // margin-bottom
    mb: {
      type: [Number, String],
      default: 0
    },
    // margin-left
    ml: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    isIconfont() {
      // 如果是以icon-开头且不是component类型的，则默认使用iconfont
      const startsWithIcon = this.type.startsWith('icon-');
      return startsWithIcon && this.attr !== 'component' || this.attr === 'iconfont';
    },
    customAttrs() {
      const obj = {};
      if (['type', 'iconfont'].includes(this.attr)) {
        obj.type = this.type;
      }
      if (this.attr === 'component') {
        obj.component = _icons.default[this.type];
      }
      obj.style = {
        fontSize: this.autoAddpx(this.size),
        color: this.color,
        margin: `${this.autoAddpx(this.mt)} ${this.autoAddpx(this.mr)} ${this.autoAddpx(this.mb)} ${this.autoAddpx(this.ml)}`,
        ...this.$vnode.data.style
      };
      return obj;
    }
  },
  methods: {
    // 判断是否有px，没有则自动添加
    autoAddpx(value) {
      if (value.toString().endsWith('em')) {
        return value;
      }
      return value.toString().indexOf('px') > -1 ? value : `${value}px`;
    }
  }
};